import { Order } from '@/@types'

const submitOrder = async (order: Order) => {
  const url = `/api/submit-order`

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(order),
    })
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}

export { submitOrder }
